import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PolicyOverview from "./sections/PolicyOverview";
import DataCollection from "./sections/DataCollection";
import UserRightsIcoInformation from "./sections/UserRightsIcoInformation";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PolicyOverview />
      <DataCollection />
      <UserRightsIcoInformation />
      <Footer />
    </div>;
}